<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-row class="view">
    <v-col class="col-12 pl-5 pr-5">
      <v-img v-for="i in [0,1,2,3]"
             v-if="promotion.product_promotions[i] && promotion.product_promotions[i].product && promotion.product_promotions[i].product.image_path"
             :src="'/'+promotion.product_promotions[i].product.image_path+'.175.jpg'"
             aspect-ratio="1"
             class="grey lighten-2 float-left"
             style="width: 50%"
      >
        <span v-if="i===3 && promotion.product_promotions.length>4"
              class="more">+{{ promotion.product_promotions.length - 4 }}</span>

      </v-img>
      <v-img
          v-else-if="promotion.product_promotions[i]"
          :src="'/images/products/default.175.jpg'"
          aspect-ratio="1"
          class="grey lighten-2 float-left"
          style="width: 50%"
      >
        <span v-if="i===3 && promotion.product_promotions.length>4"
              class="more">+{{ promotion.product_promotions.length - 4 }}</span>

      </v-img>
      <v-img
          v-else
          aspect-ratio="1"
          class="grey lighten-2 float-left"
          style="width: 50%;opacity: 0"
      >
        <span v-if="i===3 && promotion.product_promotions.length>4"
              class="more">+{{ promotion.product_promotions.length - 4 }}</span>

      </v-img>
    </v-col>
    <v-col class="detail col-12 pl-5 pr-5">
      <!--{{ promotion.nickcode}}-->
      <div class="nickname">

        {{ promotion.name }}

      </div>
    </v-col>
    <v-col class="detail pl-5">
      <div class=" text-left stock">
          <span v-if="Promotion.calStock(promotion)!=='n/a'" class="">
            <span
                class="currency">เหลือ</span> {{ $helper.number_format(Promotion.calStock(promotion)) }}<span
              class="unit">ชุด</span>
          </span>
        <span class="">
            <br/>
            <span class="currency">ราคา</span> {{ promotion.total_price }}<span
            class="currency">บ.</span>
          </span>

      </div>

    </v-col>
    <v-col class="col-12 col-md-5 text-right pr-5">
      <v-btn :class="$store.state.carts.current_promotion_map[promotion.id]?'primary':''" :loading="is_loading"
             @click.stop="onClickAddCart(promotion)">เพิ่ม
        <span v-if="$store.state.carts.current_promotion_map[promotion.id]">
              {{
            $store.state.carts.current_promotion_map[promotion.id][0].quantity / promotion.product_promotions[0].quantity
          }}</span>
      </v-btn>
    </v-col>
  </v-row>


</template>
<style lang="scss" scoped>
.view {
  .col {
    padding: 6px;
  }
}

.detail {
  font-size: 14px;
}

.nickname {
  height: 40px;
  overflow-y: hidden;
}

.stock {
  font-size: 16px;
}

.unit {
  font-size: 0.7em;
}

.percent {
  font-size: 0.7em;
}

.currency {
  /*display: block;*/
  /*width: 32px;*/
  /*float: right;*/
  font-size: 0.7em;
}

.more {
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  padding-top: 25%;
  color: #FFF;
  //font-weight: bold;
  font-size: 1.2em;
}

</style>

<script lang="ts">

import {Promotion} from '@/models/Promotion'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {},
})
export default class PromotionRowGrid extends Vue {
  @Prop() promotion: Promotion
  @Prop() onClickAddCart: Function
  @Prop() is_loading: Boolean

  Promotion = Promotion
}

</script>
